module.exports = __webpack_public_path__ + "static/media/energy-smart-testimonials-quote.f9baf693.webp";